import { useQuery } from '@apollo/client';

import { get as getUser } from 'js/lib/user';

import type {
  CheckS12nUpgradeEligibilityToS12nIdQuery,
  CheckS12nUpgradeEligibilityToS12nIdQueryVariables,
} from 'bundles/s12n-common/components/s12n-versioning-v2/queries/__generated__/checkS12nEligibilityToS12nId';
import checkS12nEligibilityToS12nId from 'bundles/s12n-common/components/s12n-versioning-v2/queries/checkS12nEligibilityToS12nId.graphql';

type Props = {
  s12nId: string;
  isSpecialization?: boolean;
};
export default function useCheckS12nUpgradeEligibility({ s12nId, isSpecialization = false }: Props) {
  const userId = getUser()?.id?.toString();

  const { data } = useQuery<
    CheckS12nUpgradeEligibilityToS12nIdQuery,
    CheckS12nUpgradeEligibilityToS12nIdQueryVariables
  >(checkS12nEligibilityToS12nId, {
    variables: {
      s12nId: s12nId!,
    },
    skip: !userId || !s12nId || !isSpecialization,
    context: { clientName: 'gatewayGql' },
  });

  return data?.OnDemandSpecializationUpgrade?.s12nUpgradeEligibilityToS12nId;
}
